import hg002StatsPlot from "../../../../content/posts/data-release-notes/giab_2023.05/hg002_stats_2023.05.jsx";
import thingyPlot from "../../../../content/posts/data-release-notes/giab_2023.05/giab_stats_2023.05.jsx";
import * as React from 'react';
export default {
  hg002StatsPlot,
  thingyPlot,
  React
};